import axios from '@/config/axios';

const state = {
    categories: null,
};

const getters = {
    getCategories: state => state.categories
};

const mutations = {
    setCategories(state, categories) {
        state.categories = categories;
    }
};

const actions = {
    getCategories: async (context) => {
        try {
            context.commit('categories/setCategories', null, {root: true});
            let response = await axios.get('/categories');
            context.commit('categories/setCategories', response.data.categories, {root: true});
        } catch (error) {
            await context.dispatch('errors/errorResponse', error.response, {root: true});
            context.commit('errors/setErrors', error.response, {root: true});
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};